import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import WhiteConfirmation from './WhiteConfirmation';

// Selectors
import {
  getStatusTrackerURL,
  getSelfCheckInFlow
} from 'store/reducers/selfCheckIn/selectors';

const mapStateToProps = state => {
  return {
    statusTrackerURL: getStatusTrackerURL(state),
    selfCheckInFlow: getSelfCheckInFlow(state)
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(WhiteConfirmation);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/WhiteConfirmation/WhiteConfirmationContainer.js